require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-diogenes-brito.json") })
        }
      }, "path---blog-author-diogenes-brito");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-diogenes-brito!./.cache/json/blog-author-diogenes-brito.json
// module id = 633
// module chunks = 231608221292675